import { useTranslation } from 'react-i18next';
import InfoCard from '@client/components/ui/cards/InfoCard';

const CustomFieldsSection = ({ fields }) => {
  const { t } = useTranslation();

  if (!fields || fields.length === 0) return null;

  const fieldsWithValue = fields.filter((f) => f.value != null && f.value !== '');
  if (fieldsWithValue.length === 0) return null;

  return (
    <>
      <h3 className="title-underlined normal-case mt-4 !text-[18px]">
        {t('common|Informations additionnelles')}
      </h3>
      <div className="grid grid-cols-1 gap-4">
        {fieldsWithValue.map((field) => (
          <InfoCard
            key={field.name}
            title={field.label}
            text={field.value}
          />
        ))}
      </div>
    </>
  );
};

export default CustomFieldsSection;
